module.exports = __webpack_public_path__ + "static/video-consulting-4b07786c35e53cbc543438e970f92c5a.jpg";